
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import * as modals from "@/lib/modals";
import BarcodeOrderMap from "@/components/order/BarcodeOrderMap.vue";

@Component({
  name: modals.barcodeMapModal,
  components: {
    BarcodeOrderMap
  }
})
export default class BarcodeMapModal extends Mixins(mixin) {
  mapkey: number = 0;
  loadingComplete: boolean = false;
  barcodes: any[];
  pins: any[] = [];
  mappablePins: any[] = [];
  selectedPinIndex: any = -1;
  hasAnyGeoLocations: boolean = false;

  async load() {
    await this.orderModule.getOrderBarcodeLocations(this.orderModule.currentOrder);

    this.createPins();
    this.show();
    this.loadingComplete = true;
  }

  unload() {
    this.reset();
  }

  showMap() {
    return this.mapkey > 0 && this.loadingComplete && this.hasAnyGeoLocations;
  }

  refreshMap() {
    this.mapkey += 1;
  }
  reset() {
    this.mapkey = 0;
    this.loadingComplete = false;
  }
  createPins() {
    var barcodes = this.orderModule.currentOrderBarcodeDetails.barcodeItems;
    var locations = this.orderModule.currentOrderBarcodeLocationDetails;

    this.pins = [];
    this.mappablePins = [];

    var ordinal = 1;
    for (let i = 0; i < barcodes.length; i++) {
      var barcode = {
        id: barcodes[i].id,
        barcode: barcodes[i].barcode,
        commodityCode: barcodes[i].commodityCode,
        quantity: barcodes[i].quantity,
        status: barcodes[i].status
      };

      var matchLocations = locations.filter(l => l.barcodeOrderItemID == barcode.id);
      if (matchLocations.length > 0) {
        this.hasAnyGeoLocations = true;
        var location = matchLocations[0];
        var matchPins = this.pins.filter(
          p => p.longitude == location.longitude && p.latitude == location.latitude
        );

        if (matchPins.length > 0) {
          matchPins[0].barcodes.push(barcode);
        } else {
          var isValid = location.longitude != 0 || location.latitude != 0;
          var pin = {
            ordinal: ordinal,
            title: isValid ? `Location #${ordinal}` : "Unknown",
            longitude: location.longitude,
            latitude: location.latitude,
            barcodes: [barcode]
          };
          if (isValid) {
            this.mappablePins.push(pin);
            ordinal++;
          }
          this.pins.push(pin);
        }
      }
    }
  }

  openPin(pinIndex) {
    this.selectedPinIndex = pinIndex;
  }
}
